import * as React from "react";
import { Types } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import StoreFinderSearchForm from "./StoreFinderSearchForm.js";
const StoreFinderSearchFormContainer = (props) => {
  const { getLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      title: getLabel("appointments.component.storeFinder.searchSubtitle")
    }),
    [getLabel]
  );
  const storeQueryFilter = React.useMemo(
    () => ({
      servicesNotAvailable: {
        containsNone: [Types.ServicesNotAvailable.APPOINTMENTS]
      }
    }),
    []
  );
  return /* @__PURE__ */ React.createElement(StoreFinderSearchForm, { ...props, labels, storeQueryFilter });
};
export {
  StoreFinderSearchFormContainer as default
};
//# sourceMappingURL=StoreFinderSearchFormContainer.js.map
